import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.6.9/js/sparta-ui-layers-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.2/js/sparta-events-utility";
import _ from "vendor/lodash";
import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import Handlebars from "vendor/handlebars";
import Templates from "global/sparta-templates-utility";
import "css!modules/global/global-social-module/6.5.0/css/global-social-module.scss.css";

const scope = {};
class globalSocialModuleTemplates extends Templates {
  constructor() {
    super();
    scope.templates = [{ name: 'global-social-module', precompiled: {"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return " boa-social-skin--"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    return "\n<script>\n  $(document).ready(function () {\n    boaSocialUtilJS.init();\n  });\n</script> ";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing;

  return "\n<div class=\"boa-social-target"
    + ((stack1 = helpers["if"].call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.skin : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" data-sparta=\"Sparta\" data-global-social-module-version=\"v6.2.0\" data-config='"
    + container.escapeExpression((helpers.json || (depth0 && depth0.json) || alias2).call(alias1,((stack1 = (depth0 != null ? depth0.globalContent : depth0)) != null ? stack1.socialDefaults : stack1),{"name":"json","hash":{},"data":data}))
    + "'></div>\n\n "
    + ((stack1 = (helpers.compare || (depth0 && depth0.compare) || alias2).call(alias1,((stack1 = (depth0 != null ? depth0.module : depth0)) != null ? stack1.externalSite : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"useData":true} }];
  }

  get templates() { return scope.templates; }
  get(templateName) {
    return Handlebars.template(_.find(this.templates, {
      name: templateName
    }).precompiled);
  }
};

export default new globalSocialModuleTemplates();
